import { Plus } from "lucide-react";
import { GALLERY } from "@/data/content";
import { Reveal } from "./Reveal";

export const Gallery = () => {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="py-24 sm:py-32 bg-ink grain relative"
    >
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12">
        <Reveal className="max-w-2xl mb-16">
          <p className="text-sm uppercase tracking-[0.3em] text-gold font-semibold mb-4">
            Our Work
          </p>
          <h2 className="font-display text-cream text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight">
            A Portfolio of Sanctuaries
          </h2>
        </Reveal>

        <div className="columns-1 sm:columns-2 lg:columns-3 gap-5 [column-fill:_balance]">
          {GALLERY.map((g, i) => (
            <Reveal key={i} delay={(i % 3) * 0.08} className="mb-5 break-inside-avoid">
              <div
                data-testid={`gallery-item-${i}`}
                className="group relative overflow-hidden cursor-pointer"
              >
                <img
                  src={`${g.url}?auto=format&fit=crop&w=800&q=80`}
                  alt={g.alt}
                  loading="lazy"
                  className={`w-full object-cover transition-transform duration-700 group-hover:scale-110 ${
                    g.tall ? "h-[520px]" : "h-[340px]"
                  }`}
                />
                <div className="absolute inset-0 bg-forest/0 group-hover:bg-forest/70 transition-colors duration-500 flex items-center justify-center">
                  <div className="w-14 h-14 border border-gold flex items-center justify-center opacity-0 scale-75 group-hover:opacity-100 group-hover:scale-100 transition-all duration-500">
                    <Plus className="text-gold" size={26} />
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
